export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST';
